import FormikSingleChackboxField from './FormikSingleCheckboxField';

export default FormikSingleChackboxField;
